/** 对齐方式 radio 值 → req.data_keys / req.ai_analysis 字段名（默认映射） */
export const DEFAULT_ALIGNMENT_DATA_KEY_MAP: Record<string, string> = {
  natural_day_aligned: 'natural_day',
  version_aligned: 'last_year_version',
};

/**
 * 将对齐方式 radio 值映射为 data_keys / ai_analysis 的字段名
 * @param value - 当前对齐方式
 * @param alignmentDataKeyMap - 可选覆盖映射，未命中时回退默认映射，再回退原值
 */
export function getAlignmentAiDataKeyField(
  value?: string,
  alignmentDataKeyMap?: Record<string, string | undefined>,
): string {
  if (!value) {
    return '';
  }
  const map = {
    ...DEFAULT_ALIGNMENT_DATA_KEY_MAP,
    ...alignmentDataKeyMap,
  };
  return map[value] ?? value;
}
